// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detailSection form[data-v-4f7b60ba] {\n  padding-bottom: 80px;\n}", ""]);
// Exports
module.exports = exports;
